import React, { useState } from "react";
import Loader from "../../../core/common/loader";
import api from "../../../services/api";
import { showBasicAlert } from "../../../core/common/useAlert";

const ChangePassword = () => {
  const signature = localStorage.getItem("signature");
  const [isLoading, setIsLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handlePasswordUpdate = async () => {
    if (!newPassword || !confirmPassword) {
      return showBasicAlert("Please enter both password fields.");
    }

    if (newPassword !== confirmPassword) {
      return showBasicAlert("Passwords do not match.");
    }

    try {
      setIsLoading(true);
      const response = await api.post("userService/changeUserPassword", {
        signature,
        newPassword,
      });

      showBasicAlert(response.data.message[0].msg);
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("Error updating password:", error);
      showBasicAlert("Failed to update password.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <Loader />}

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "2rem",
        }}
      >
        <div
          style={{
            background: "#ffffff",
            padding: "2.5rem",
            borderRadius: "16px",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.08)",
            maxWidth: "450px",
            width: "100%",
          }}
        >
          <h4 style={{ marginBottom: "1.5rem", textAlign: "center" }}>
            🔐 Change Your Password
          </h4>

          <div style={{ position: "relative", marginBottom: "1.5rem" }}>
            <label style={{ display: "block", marginBottom: "0.5rem" }}>
              New Password
            </label>
            <input
              type={showNewPassword ? "text" : "password"}
              style={{
                width: "100%",
                padding: "0.75rem",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "1rem",
              }}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
            />
            <i
              className={`ti ${showNewPassword ? "ti-eye-off" : "ti-eye"}`}
              style={{
                position: "absolute",
                right: "15px",
                top: "45px",
                fontSize: "1.1rem",
                color: "#666",
                cursor: "pointer",
              }}
              onClick={() => setShowNewPassword(!showNewPassword)}
            />
          </div>

          <div style={{ position: "relative", marginBottom: "1.5rem" }}>
            <label style={{ display: "block", marginBottom: "0.5rem" }}>
              Confirm Password
            </label>
            <input
              type={showConfirmPassword ? "text" : "password"}
              style={{
                width: "100%",
                padding: "0.75rem",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "1rem",
              }}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
            />
            <i
              className={`ti ${showConfirmPassword ? "ti-eye-off" : "ti-eye"}`}
              style={{
                position: "absolute",
                right: "15px",
                top: "45px",
                fontSize: "1.1rem",
                color: "#666",
                cursor: "pointer",
              }}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            />
          </div>

          <button
            onClick={handlePasswordUpdate}
            style={{
              width: "100%",
              padding: "0.75rem",
              backgroundColor: "#F26522",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "background 0.3s",
            }}
            onMouseOver={(e: any) =>
              (e.target.style.backgroundColor = "#1e3a5f")
            }
            onMouseOut={(e: any) =>
              (e.target.style.backgroundColor = "#F26522")
            }
          >
            Update Password
          </button>
        </div>

        <div style={{ marginTop: "2rem", textAlign: "center", color: "#666" }}>
          <p style={{ margin: 0 }}>
            2025 © CMS. Designed & Developed by{" "}
            <a href="#" style={{ color: "#2c5282", textDecoration: "none" }}>
              ZYVO
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
